module.exports = __webpack_public_path__ + "static/img/bgRoll.0fcdd892.png";